export enum ModuleType {
  DT = 'decisiontrees',
  DTT = 'GuidanceTitle',
  PG = 'picture-guides',
  LMS = 'lms',
  FAQ = 'faqs',
  Article = 'articles',
  SOP = 'SOP',
  Document = 'document',
  Collab = 'Collaboration',
  Tickler = 'Tickler',
  Broadcast = 'Broadcast',
  Banner = 'Banner',
  Template = 'Template',
  DocumentLibrary = 'DocumentLibrary',
  Templates = 'templates'
}
export enum AgentUIModuleType {
  DT = 'decision-tree',
  PG = 'picture-guide',
  FAQ = 'faqs',
  LMS = 'assessments',
  Article = 'articles',
  Document = 'document',
  SOP = 'SOP'
}
export enum ControllerPrefixToServiceMasterModuleMapping {
  'articles' = 'Articles',
  'faqs' = 'FAQ',
  'picture-guides' = 'Picture Guide',
  'decisiontrees' = 'Decision Tree',
  'document' = 'Document',
  'SOP' = 'SOP'
}
export enum ElasticModuleType {
  DT = 'GuidanceTitle',
  PG = 'PictureGuideTitle',
  FAQ = 'FaqTitle',
  Article = 'Article',
  NoResult = 'NoResult',
  Collab = 'Collaboration',
  LMS = 'LMSTitle',
  Document = 'Document',
  SOP = 'SOP'
}

export enum MenuType {
  Menu = 0,
  SubMenu,
  ServicePlan,
  Tools
}
export enum Direction {
  LTR = 'ltr',
  RTL = 'rtl'
}

export enum ServiceCode {
  DT = 'DT_29891S',
  PG = 'PG_27488S',
  FAQ = 'FA_39541S',
  Article = 'AR_45309S',
  LMS = 'LMS_29891S',
  LMS_ASSESSMENT = 'LMS_A_29891S',
  Document = 'DOC_592382',
  SOP = 'SOP_45539S'
}

export enum ServiceName {
  MAGICWAND = 'autofix',
  AI_TRANSLATE = 'ai-translate',
  DT = 'Decision-Tree',
  PG = 'Picture-Guide',
  session = 'session',
  FAQ = 'FAQ',
  REVIEW_WORKFLOW = 'review-workflow',
  GLOBALSEARCHANDREPLACE = 'global-search-replace',
  SelfService = 'self-service',
  Translations = 'translations',
  ShowLSQTheme = 'show-only-lsq-theme',
  BulkSoftDelete = 'bulk-soft-delete',
  Article = 'Articles',
  Document = 'Document',
  SOP = 'SOP',
  LMS = 'Lms',
  UM = 'User-Management',
  MISC = 'Miscellaneous',
  KnowledgeGraph = 'knowledge-graph',
  Client = 'Billing-Module',
  PGVideo = 'PG-Video',
  DocumentLibrary = 'Document-Library',
  GenerateDecisionTree = 'Gen-AI-DT',
  MaxAiDT = 'max-ai-dt',
  Webhook = 'Webhook',
  Sentry = 'sentry',
  Summary = 'Summary',
  Learning = 'learning',
  SyncUser = 'sync-user',
  IMPORT_CONTENT = 'import-content',
  EXPORT_CONTENT = 'export-content',
  PreviewThemeSelection = 'preview-theme-selection',
  ExtensionThemeSelection = 'extension-theme-selection',
  disableAIKeywords = 'disable-ai-keywords',
  DeepLinkAnotherTree = 'deep-link-another-tree',
  INHERITED_NODE_ATTRIBUTE = 'inherited-node-attributes',
  CERTIFICATES_UNIVERSAL_FONTS = 'certificates-universal-fonts',
  CLIENT_EXECUTION_SCRIPT = 'client-exec-script',
  AI_PROMPT_LIBRARY = 'ai-prompt-library',
  RECENTLY_UPDATED_MAX_COUNT = 'recently-updated-max-count_enabled'
}

export const featureFlags = {
  AI_GENERATED_CATEGORY: 'ai-generated-category',
  recommendCategory: 'recommendCategory',
  DISABLE_CROSS_DEPT_CONTENT_CREATION: 'disable-cross-dept-content-creation',
  LABEL: 'label',
  CAN_ADMIN_CHANGE_DEPT: 'can-admin-change-dept',
  RENAME_MENU_LINKS: 'rename-menu-links',
  ENTITIES_COMPARISONS: 'entities-comparison',
  GAMIFICATION: 'gamification',
  EXTRACT_DEPT_NAME_FROM_ROLE: 'extract-dept-name-from-role',
  SEARCH_ROLE_AGAINST_DEPARTMENT: 'search-role-against-department',
  ASKAI: 'Ask-AI',
  ASSIGN_DEFAULT_CATEGORY: 'assign-default-category',
  ASSIGN_LOCATION: 'assign-location',
  DT_YAML: 'dt-yaml',
  DT_SOP: 'download-SOP',
  BLANK_TEMPLATE_ENABLED: 'blank-template-enabled',
  VODAFONE_FONT: 'vodafone-font',
  ENABLE_JS_EXECUTION_ARTICLES_VODAFONE_QATAR: 'enable_js_execution_articles_vodafone_qatar',
  DASHBOARD_CUSTOMIZATION: 'dashboard-customization',
  MAF_ARTICLE_TEMPLATES: 'maf-article-templates',
  MAGENTA_PREVIEW: 'magenta-preview',
  FEDERATED_SEARCH: 'federated-search',
  PDF_READ: 'pdf-read',
  MAX_AI_ARTICLE: 'max-ai-article',
  MAX_AI_FAQ: 'max-ai-faq',
  MAX_AI_PG_GENERATION: 'max-ai-pg-generation',
  PGVECTOR_TYPESENSE: 'pgvector-typesense',
  MAX_AI_QUIZ: 'max-ai-assessment',
  MAX_AI_COURSE: 'max-ai-course',
  // * Gates the v1 inbound content push and, with it, creating an Ingestion channel at all
  CONTENT_INGESTION: 'Content-Ingestion'
}

export const ElasticModuleTypeToModuleType = {
  GuidanceTitle: ModuleType.DT,
  PictureGuideTitle: ModuleType.PG,
  FaqTitle: ModuleType.FAQ,
  Article: ModuleType.Article,
  Document: ModuleType.Document,
  Collaboration: ModuleType.Collab,
  LMS: ModuleType.LMS,
  SOP: ModuleType.SOP
}
export class OtherModule {
  contentId: string
  contentType: ModuleType
  linkModuleId: string
  linkModuleType: ModuleType
  displayName: string
  guidanceTitle: string
}

export class MediaListData {
  createdBy: string
  createdDate: string
  displayName: string
  isMasterEntry: boolean
  isSaveToLibrary: boolean
  mediaName: string
  mediaPath: string
  mimeType: string
  modifiedBy: string
  modifiedDate: string
  status: number
}

export enum SearchSortType {
  Popularity = 0,
  Updation,
  Rating,
  Alphabetically
}

export class LinkAnotherModule {
  contentId: string
  contentTitle: string
  contentType: string
  serviceCode: string
}
export enum StatusTypeTranslation {
  Inactive = 0,
  Active = 1,
  All = 2
}
export enum UITypes {
  SELFSERVICE = 'SELFSERVICE',
  ADMIN = 'ADMIN',
  CLIENT = 'CLIENT',
  AGENT = 'AGENT',
  UI = 'UI',
  ADMIN_UI = 'ADMIN_UI'
}

export enum CommentPanelType {
  Create_Review_Comment = 'Create_Review_Comment',
  Review_Comment = 'Review_Comment',
  Agent_Feedback = 'Agent_Feedback',
  Content_compliance_grammar = 'Content_compliance_grammar',
  Content_compliance_spell = 'Content_compliance_spell',
  Content_compliance_broken_link = 'Content_compliance_broken_link',
  Content_compliance_formal_language = 'Content_compliance_formal_language'
}
export enum StatusType {
  Inactive = 0,
  Active = 1,
  Delete = 2,
  Draft = 3,
  Replaced = 4,
  Archive = 5,
  Scheduled = 6,
  Review = 8
}
export enum Status {
  Draft = 'Draft',
  Live = 'Live',
  PendingApproval = 'PendingApproval',
  Approved = 'Approved',
  Archive = 'Archive',
  Inactive = 'Inactive'
}
export const StatusTypeText = {
  0: 'Inactive',
  1: 'Active',
  2: 'Delete',
  3: 'Draft',
  4: 'Replaced'
}
export enum BroadcastType {
  USER_GENERATED = 0,
  SYSTEM_GENERATED = 1
}

export enum BroadcastPriority {
  LOW = 2,
  MEDIUM = 1,
  HIGH = 0
}
export const ServicePoliciesToModule = {
  articles: 'Articles',
  faqs: 'FAQ',
  'picture-guides': 'Picture Guide',
  decisiontrees: 'Decision Tree',
  document: 'Document',
  SOP: 'SOP'
}
export enum EnumModuleType {
  Article = 'Article',
  Document = 'Document',
  DecisionTree = 'DecisionTree',
  PictureGuide = 'PictureGuide',
  FAQ = 'FAQ',
  Quiz = 'Quiz',
  Course = 'Course',
  Snippet = 'Snippet',
  SOP = 'SOP',
  InquiryDesk = 'InquiryDesk'
}
export enum CodeTypeEnum {
  Head = 'head',
  BodyStart = 'bodyStart',
  BodyEnd = 'bodyEnd',
  Style = 'customStyle'
}
export enum CodeUrlEnum {
  Head = 'headCodeUrl',
  BodyStart = 'bodyStartCodeUrl',
  BodyEnd = 'bodyEndCodeUrl',
  Style = 'customStyleCodeUrl'
}
export enum FeedbackType {
  ALL = 'ALL',
  INCORRECT_INFORMATION = 'INCORRECT INFORMATION',
  IRRELEVANT_INFORMATION = 'IRRELEVANT INFORMATION',
  GENERAL = 'GENERAL',
  SUGGESTION = 'Publisher Suggestion',
  PUBLISHER_SUGGESTION = 'Publisher Suggestion',
  CONTENT_SUGGESTION = 'SUGGESTION',
  CONTENT_REQUEST = 'CONTENT REQUEST',
  OTHER = 'OTHER'
}

export enum FeedbackBy {
  ADMIN = 'ADMIN',
  AGENT = 'AGENT'
}

export enum Layout {
  Left = 'Left',
  Right = 'Right',
  Top = 'Top',
  Bottom = 'Bottom'
}
export enum BackgroundLayout {
  TopLeft = 'TopLeft',
  TopRight = 'TopRight',
  BottomLeft = 'BottomLeft',
  BottomRight = 'BottomRight',
  Middle = 'Middle'
}

export enum Model {
  MODEL_1 = 'gpt-4',
  MODEL_2 = 'model-3'
}

export enum ComplianceServices {
  BROKEN_LINK = 'BROKEN_LINK',
  SPELL_CHECK = 'SPELL_CHECK',
  GRAMMAR_CHECK = 'GRAMMAR_CHECK',
  FORMAL_LANGUAGE = 'FORMAL_LANGUAGE',
  REPETITION = 'REPETITION',
  CATEGORY_DEPARTMENT_VALIDATION = 'CATEGORY_DEPARTMENT_VALIDATION'
}

export const languageBCPCode = {
  ms: 'ms-MY',
  hi: 'hi-IN',
  ar: 'ar-SA',
  zh: 'zh-CN',
  cs: 'cs-CZ',
  da: 'da-DK',
  nl: 'nl-NL',
  fi: 'fi-FI',
  fr: 'fr-FR',
  de: 'de-DE',
  el: 'el-GR',
  hu: 'hu-HU',
  id: 'id-ID',
  it: 'it-IT',
  ja: 'ja-JP',
  ko: 'ko-KR',
  no: 'no-NO',
  pl: 'pl-PL',
  pt: 'pt-PT',
  ro: 'ro-RO',
  ru: 'ru-RU',
  sk: 'sk-SK',
  es: 'es-ES',
  sv: 'sv-SE',
  th: 'th-TH',
  tr: 'tr-TR',
  uk: 'uk-UA',
  vi: 'vi-VN'
}

export const AuthorizationPrefixes = ['/api/v2/billing', '/api/v2/users']

export const ByPassAuthTokenPrefixes = ['/api/v2/users/login-actions', '/api/v2/users/ui-info']
